import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from '../utils/apiClient';

function useSessionTimeout(interval = 60000) {
  const dispatch = useDispatch();
  // const { isLoggedIn, email } = useSelector((state) => ({
  //   isLoggedIn: state.isLoggedIn,
  //   email: state.email,
  // }));
  const { sessionId, email } = useSelector((state) => ({
    sessionId: state.sessionId,
    email: state.email,
  }));
  // console.log(email,sessionId)
  useEffect(() => {
    const validateSession = async () => {
      if (!email || !sessionId) {
        return;
      }
      try {
        const endpoint = `/validate-session?email=${encodeURIComponent(email)}&sessionId=${encodeURIComponent(sessionId)}`;
        const result = await API.call(endpoint, 'GET');

        if (!result.success) {
          alert('Your session has expired. Please log in again.');
          dispatch({ type: 'LOGOUT' });
          localStorage.clear();
          window.location.href = '/Login';
        }
      } catch (error) {
        console.error('Error during session validation:', error);
      }
    };

    const intervalId = setInterval(validateSession, interval);

    return () => {
      clearInterval(intervalId);
    };
  }, [dispatch, interval]);

  return null;
}
export default useSessionTimeout;
